import { createContext, useContext, useState, ReactNode } from 'react';

export type ErrorState = {
    status: number;
    message: string;
} | null;

interface ErrorContextType {
    error: ErrorState;
    setError: (error: ErrorState) => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
    const [error, setError] = useState<ErrorState>(null);

    return (
        <ErrorContext.Provider value={{ error, setError }}>
            {children}
        </ErrorContext.Provider>
    );
};

export const useError = () => {
    const context = useContext(ErrorContext);

    if (context === undefined) {
        throw new Error('Context is undefined');
    }

    return context;
};
